var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircularArrow = function SvgCircularArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A2550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.733 3.99 2.256 2.243m0 0-2.243 2.256m2.243-2.256-9 .026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A2550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.268 16.01 4.01 13.768m0 0 2.244-2.256M4.01 13.767l9-.026"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A2550",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M3.998 9.267A3 3 0 0 1 6.989 6.26M16.003 10.733a3 3 0 0 1-2.992 3.008"
  })));
};
export default SvgCircularArrow;